// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.date-filter-form-detailed {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.detailed-date-field {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 20px); /* Three fields per row */
    min-width: 250px; /* Minimum width for fields */
    display: flex;
    flex-direction: column;
}

.detailed-date-field label {
    font-size: 14px;
    margin-bottom: 8px;
    color: #333;
    text-align: left;
}

.detailed-date-field input {
    width: 94%;
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 10px 0px;
}

.detailed-form-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

.detailed-form-actions .btn {
    padding: 10px 20px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.detailed-form-actions .submit-btn {
  background-color: #44a67e;
  border-color: #44a67e;
}

.detailed-form-actions .submit-btn:hover {
  background-color: #44a67e;
  border-color: #44a67e;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}

.detailed-form-actions .download-btn {
  background: #373435;
  color: #ffcc29;
}

.detailed-form-actions .download-btn:hover {
  background: #373435;
  color: #ffcc29;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}


/* Table style for detailed report */
  .detailed-report-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .detailed-report-table th,
  .detailed-report-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .detailed-report-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .detailed-report-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .detailed-report-table tbody tr:hover {
    background-color:  rgba(255, 204, 41, 0.2);
  }
  
  .detailed-report-table td {
    color: #373435;
  }
  
  .detailed-report-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }

  /* Expand Button */
  .detailed-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .detailed-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }
  
  /* Expanded Row */
  .detailed-expanded-row {
    background-color: #eef7ff;
  }
  
  .detailed-expanded-content {
    padding: 10px;
  }

  .wrap-detailed-report {
    margin: 0 40px;
  }`, "",{"version":3,"sources":["webpack://./src/components/DetailedReport.js/DetailedReport.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;IACI,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B,EAAE,yBAAyB;IACzD,gBAAgB,EAAE,6BAA6B;IAC/C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qFAAqF;AACvF;;;AAGA,oCAAoC;EAClC;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB","sourcesContent":["\r\n.date-filter-form-detailed {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.detailed-date-field {\r\n    flex: 1 1 calc(33.333% - 20px); /* Three fields per row */\r\n    min-width: 250px; /* Minimum width for fields */\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.detailed-date-field label {\r\n    font-size: 14px;\r\n    margin-bottom: 8px;\r\n    color: #333;\r\n    text-align: left;\r\n}\r\n\r\n.detailed-date-field input {\r\n    width: 94%;\r\n    padding: 8px;\r\n    font-size: 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    margin: 10px 0px;\r\n}\r\n\r\n.detailed-form-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.detailed-form-actions .btn {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.detailed-form-actions .submit-btn {\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n}\r\n\r\n.detailed-form-actions .submit-btn:hover {\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n}\r\n\r\n.detailed-form-actions .download-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n}\r\n\r\n.detailed-form-actions .download-btn:hover {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n}\r\n\r\n\r\n/* Table style for detailed report */\r\n  .detailed-report-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .detailed-report-table th,\r\n  .detailed-report-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .detailed-report-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .detailed-report-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .detailed-report-table tbody tr:hover {\r\n    background-color:  rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .detailed-report-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .detailed-report-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n\r\n  /* Expand Button */\r\n  .detailed-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .detailed-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n  \r\n  /* Expanded Row */\r\n  .detailed-expanded-row {\r\n    background-color: #eef7ff;\r\n  }\r\n  \r\n  .detailed-expanded-content {\r\n    padding: 10px;\r\n  }\r\n\r\n  .wrap-detailed-report {\r\n    margin: 0 40px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
